import { useTranslation } from "react-i18next";

import { useDotNavigation } from "@aviary/components/NewCarousel/DotNavigation/useDotNavigation";
import type { EmblaCarouselType } from "@aviary/components/NewCarousel/emblaCarouselTypes";

import { useAutoplay } from "../useAutoplay";

import { BarButton } from "./BarButton";
import { PlayPauseButton } from "./PlayPauseButton";

import * as styles from "./BarNavigation.styles";

interface Props {
  emblaApi: EmblaCarouselType;
}

/**
 * @deprecated DS4 component — DS5 support is in progress. Do not add new usages.
 */
const BarNavigation = ({ emblaApi }: Props) => {
  const { t } = useTranslation();
  const { selectedIndex, scrollSnaps, onDotButtonClick, renderAriaLabel } =
    useDotNavigation(emblaApi);
  const { isPlaying } = useAutoplay(emblaApi);

  const { onButtonAutoplayClick } = useAutoplay(emblaApi);

  const handleButtonClick = (index: number) => onButtonAutoplayClick(() => onDotButtonClick(index));

  const renderBars = scrollSnaps.map((_, index) => {
    return (
      <li key={index}>
        <BarNavigation.Button
          value={0}
          aria-label={t(renderAriaLabel(index))}
          isSelected={index === selectedIndex}
          isAutoplay={isPlaying}
          onClick={() => handleButtonClick(index)}
        />
      </li>
    );
  });

  return (
    <div css={styles.navWrapper}>
      <ul css={styles.barWrapper} data-testid="bar-navigation">
        {renderBars}
      </ul>
      <PlayPauseButton emblaApi={emblaApi} />
    </div>
  );
};

BarNavigation.displayName = "InformationCarousel.BarNavigation";
BarNavigation.Button = BarButton;

export { BarNavigation };
